import logo1 from "../assets/images/ADAT_logo_16avr25.jpg";
import logo2 from "../assets/images/ESA-03_logo_dark_blue.bmp";
import logo3 from "../assets/images/sfpt_rfpt_v2.png";
import logo4 from "../assets/images/GEODATA Paris.jpg";
import logo5 from "../assets/images/LASTIG-2.jpg";
import logo6 from "../assets/images/Logo_Université_de_Fianarantsoa.png";
import logo7 from "../assets/images/Université_Gustave_Eiffel.png";
import logo8 from "../assets/images/EMIT.png";
import logo9 from "../assets/images/unesco_mab.jpeg";
import logo10 from "../assets/images/universite_de_douala.jpeg";
import logo11 from "../assets/images/IOGA.jpeg";

// Import all Calque logos
const calqueLogos = [];
try {
  calqueLogos.push(require(`../assets/images/Logos/Calque 28.png`));
} catch (e) {
  console.warn(`Could not load Calque 28.png`);
}

// Combine existing logos with Calque logos
const images = [
  logo6,
  logo7,
  logo8,
  logo9,
  logo10,
  logo11,
  logo1,
  logo2,
  logo3,
  logo4,
  logo5,
  ...calqueLogos,
];

const partnerNames = [
  "Université de Fianarantsoa",
  "Université Gustave Eiffel",
  "EMIT",
  "UNESCO MAB",
  "UDO",
  "IOGA",
  "ADAT",
  "ESA",
  "SFPT RFPT",
  "GEODATA",
  "LASTIG",
  "MADATLAS",
];

// Add generic names for Calque logos
for (let i = 1; i <= 30; i++) {
  partnerNames.push(`Partenaire ${partnerNames.length + 1}`);
}

function Carrousel() {
  return (
    <div className="w-full my-10">
      <h2 className="text-2xl font-bold text-center mb-8 text-radar-700">
        Nos Partenaires
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
        {images.map((image, index) => (
          <div
            key={index}
            className="bg-white rounded-lg shadow-sm overflow-hidden transition-transform hover:scale-105 hover:shadow-md"
          >
            <div className="p-4 flex flex-col items-center">
              <div className="h-28 w-28 flex justify-center items-center mb-3">
                <img
                  src={image}
                  alt={
                    index < partnerNames.length
                      ? partnerNames[index]
                      : `Logo ${index + 1}`
                  }
                  className="max-h-full max-w-full object-contain"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Carrousel;
